import { LinksTable } from "components";

const Links = () => {
    return (
        <LinksTable />
    );
};

export default Links;
